import React, { useEffect, useState } from 'react'
import AdminNavbar from '../../../components/CommonComponents/AdminNavbar'
import { donwloadCSV, downloadPDF, downloadXLSX } from '../../../components/CommonMethod/CommonMethods';
import AdminTable from '../../../components/CommonComponents/AdminTable';
import axios from 'axios';
import MessageBox from '../../../components/CommonComponents/MessageBox';
import { FaEllipsisVertical } from "react-icons/fa6";
import { toast } from 'react-toastify';
import Response_Processing from '../../../layout/Others/Response_Processing';
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect';
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { RxReload } from 'react-icons/rx';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import { connect } from 'react-redux';
import AdminTooltip from '../../../components/CommonComponents/AdminTooltip';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import AdminVideoStatus from '../../../components/CommonComponents/AdminVideoStatus';

// ===============================
// CONFIRMATION MODAL COMPONENT
// ===============================
// ===============================
// CONFIRMATION MODAL COMPONENT (Bootstrap-style)
// ===============================
const ConfirmationModal = ({ visible, action, count, onConfirm, onClose }) => {
    if (!visible) return null;

    return (
        <div
            className="modal fade show"
            style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 2000
            }}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-3 shadow">
                    {/* Header */}
                    <div className="modal-header border-0">
                        <h5 className="modal-title fw-bold">
                            {action === "approve"
                                ? "Confirm Approve"
                                : "Confirm Disapproved"}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={onClose}
                        ></button>
                    </div>

                    {/* Body */}
                    <div className="modal-body">
                        <p className="mb-0">
                            Are you sure you want to{" "}
                            <strong>
                                {action === "approve" ? "approve" : "disapproved"}
                            </strong>{" "}
                            {count > 1
                                ? `${count} selected items`
                                : "this item"}?
                        </p>
                    </div>

                    {/* Footer */}
                    <div className="modal-footer border-0">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className={`btn ${action === "approve"
                                ? "btn-success"
                                : "btn-danger"
                                }`}
                            onClick={onConfirm}
                        >
                            {action === "approve" ? "Approve" : "Disapproved"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const AllPartnercontent = ({ permissionData }) => {
    const BaseUrl = process.env.REACT_APP_Baseurl;
    const { fetchRequest } = useMyContext();

    // endpoints
    const approvePendingApi = `${BaseUrl}/admin/partner/approve-pending`;
    const approveListApi = `${BaseUrl}/admin/partner/approve-list`;
    const rejectListApi = `${BaseUrl}/admin/partner/reject-list`;

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10);
    const [ApprovalActionType, setApprovalActionType] = useState(2);
    const [apiData, setApiData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState('');
    const [itemToApproval, setItemToApproval] = useState([]);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithoutRefresh] = useState(false)
    const [activeId, setActiveId] = useState(null)
    const [formData, setFormData] = useState({
        state: "formData",
        view_type: "list",
        view_type_option: [
            { name: "List", value: "list" },
            { name: "Gallery", value: "grid" }
        ]
    })

    // new states for selects
    const [datapartner, setDatapartner] = useState([]);
    const [loadingpartner, setLoadingpartner] = useState(false);
    const [selectedPartner, setSelectedPartner] = useState("0");
    const [selectedSource, setSelectedSource] = useState("1"); // default to Video
    const [noSelectionYet, setNoSelectionYet] = useState(true);

    // modal states
    const [modalVisible, setModalVisible] = useState(false);
    const [modalAction, setModalAction] = useState(null);
    const [modalContentIds, setModalContentIds] = useState([]);

    // ===========================
    // FETCH PARTNER LIST
    // ===========================
    useEffect(() => {
        const fetchDataofAllPartners = async () => {
            try {
                setLoadingpartner(true);
                const access_token = localStorage.getItem("access_token");
                const headers = {
                    Authorization: `Bearer ${access_token}`,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                };
                const response = await axios.get(`${BaseUrl}/admin/partner/index`, {
                    params: { page: 1, limit: 50, all: true },
                    headers,
                });
                if (response?.status === 200 && response?.data) {
                    const payload = response.data.data || response.data.result || [];
                    setDatapartner(payload);
                    // ✅ trigger default fetch for first partner
                    if (payload.length > 0) {
                        setSelectedPartner(String(payload[0].id));
                    }
                } else {
                    setDatapartner([]);
                }
            } catch (error) {
                console.error("Error fetching partners:", error);
                setDatapartner([]);
            } finally {
                setLoadingpartner(false);
            }
        };
        fetchDataofAllPartners();
    }, [BaseUrl]);

    // ===========================
    // FETCH PENDING ITEMS
    // ===========================
    const fetchPendingForPartner = async (partner_id, source_type) => {
        if (!partner_id || partner_id === "0" || !source_type || source_type === "0") {
            setApiData([]);
            setTotal({ totalItems: 0 });
            setLoading(false);
            return;
        }

        setLoading(true);
        setNoSelectionYet(false);
        const access_token = localStorage.getItem("access_token");
        try {
            const headers = {
                Authorization: `Bearer ${access_token}`,
                "Content-Type": "application/json",
                Accept: "application/json",
            };
            const payload = {
                partner_id: Number(partner_id),
                source_type: Number(source_type)
            };
            const response = await axios.post(approvePendingApi, payload, { headers });

            const resultList = response?.data?.data || response?.data?.result || response?.data || [];
            const normalized = (Array.isArray(resultList) ? resultList : []).map(item => ({
                ...item,
                id: item.id ?? item.content_id ?? item.contentId,
                title: item.title ?? item.name ?? item.content_title,
                source_type: item.source_type ?? item.type,
                uploaded_by: "Partner",
                status: item.status ?? item.approval_status ?? item.active ?? 0,
            }));

            setApiData(normalized);
            setTotal({ totalItems: normalized.length, count_all: normalized.length });
        } catch (err) {
            console.error("Error fetching pending items:", err);
            // toast.error(err?.response?.data?.message || "Failed to fetch pending items");
            setApiData([]);
            setTotal({ totalItems: 0 });
        } finally {
            setLoading(false);
        }
    };

    // ===========================
    // AUTO FETCH ON DEFAULT LOAD & CHANGE
    // ===========================
    useEffect(() => {
        if (selectedPartner !== "0" && selectedSource !== "0") {
            fetchPendingForPartner(selectedPartner, selectedSource);
        } else {
            setApiData([]);
            setTotal({ totalItems: 0 });
            setLoading(false);
        }
    }, [selectedPartner, selectedSource, withOutRefresh]);

    // ===========================
    // APPROVE / REJECT API CALL
    // ===========================
    const apiActionForContent = async (action, contentIds) => {
        if (!selectedPartner || selectedPartner === "0" || !selectedSource || selectedSource === "0") {
            toast.warn("Please choose Partner and Content Source first.");
            return;
        }
        if (!Array.isArray(contentIds) || contentIds.length === 0) {
            toast.warn("Please select at least one item.");
            return;
        }

        setShowOverlay(true);
        const access_token = localStorage.getItem("access_token");
        const headers = {
            Authorization: `Bearer ${access_token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
        };

        const payload = {
            partner_id: Number(selectedPartner),
            source_type: Number(selectedSource),
            content_ids: contentIds.map(id => Number(id)),
        };

        try {
            let response;
            if (action === "approve") {
                response = await axios.post(approveListApi, payload, { headers });
            } else {
                response = await axios.post(rejectListApi, payload, { headers });
            }

            const message = response?.data?.message || `${action === "approve" ? "Approved" : "Rejected"} successfully`;
            toast.success(message);

            setItemToApproval([]);
            setWithoutRefresh(prev => !prev);
            fetchPendingForPartner(selectedPartner, selectedSource);
        } catch (err) {
            console.error("Action error:", err);
            toast.error(err?.response?.data?.message || `Failed to ${action}`);
        } finally {
            setShowOverlay(false);
        }
    };

    // ===========================
    // MODAL HANDLERS
    // ===========================
    const openModal = (action, ids) => {
        setModalAction(action);
        setModalContentIds(ids);
        setModalVisible(true);
    };
    const closeModal = () => setModalVisible(false);
    const confirmModalAction = () => {
        apiActionForContent(modalAction, modalContentIds);
        closeModal();
    };

    // ===========================
    // ROW SELECTION
    // ===========================
    const selectRow = { selected: itemToApproval };
    const handleRowSelect = (rowId) => {
        if (itemToApproval.includes(rowId)) {
            setItemToApproval(itemToApproval.filter((id) => id !== rowId));
        } else {
            setItemToApproval([...itemToApproval, rowId]);
        }
    };
    const handleSelectAll = () => {
        if (itemToApproval.length === apiData.length) {
            setItemToApproval([]);
        } else {
            setItemToApproval(apiData.map((row) => row.id));
        }
    };

    // ===========================
    // OTHER HANDLERS
    // ===========================
    const handleInput = (e) => {
        const { type, name, value } = e.target
        if (type === "search" || type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }))
        }
    }

    const reloadAction = () => { setWithoutRefresh(prev => !prev); };

    const handlePageChange = (p) => setPage(p);
    const handleSizePerPageChange = (e) => { setLimit(Number(e.target.value)); setPage(1); };

    // ===========================
    // TABLE COLUMNS
    // ===========================
    const columns = [
        {
            dataField: "title",
            text: "Title",
            width: "30%",
            formatter: (cell, row) =>
                <>
                    <div className='d-flex'>
                        <img src={row?.image_url} className="profile theme-bg-color-secondary" />
                        <div>

                            <h4 className='table-column-title  mb-2'>{row?.title}</h4>
                            <div className='d-flex align-items-center flex-wrap gap-2 justify-content-start'>
                                <span className='dateText table-subheading theme-text-color'>{row?.duration}</span>
                            </div>
                        </div>
                    </div>
                </>,
            sort: true,
        },
        {
            dataField: "uploaded_by",
            text: "Uploaded By",
            formatter: (cell, row) => (
                <div className="d-flex w-100 px-3 py-1 ">
                    {row.uploaded_by}
                </div>
            ),
        },
        {
            dataField: "status",
            text: "Status",
            formatter: (cell, row) => {
                const isDisapproved = cell === 2 || row?.active === 2 || row?.status === 2;
                const isPublished = cell === 1 || cell === "PUBLISHED";
                const isScheduled = cell === "SCHEDULED";
                const isPending = cell === 0 || cell === null || cell === undefined || cell === "PENDING";

                let statusText = cell;
                if (isDisapproved) statusText = "DISAPPROVED";
                else if (isPending) statusText = "PENDING";

                const statusClass = isPublished ? "PUBLISHED_active" : isScheduled ? "DISABLED_active" : isPending ? "DISABLED_active" : "UNPUBLISHED_active";

                return (
                    <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${statusClass}`}>
                        <p className='' style={{ fontSize: "10px", fontWeight: "700" }}>{statusText}</p>
                    </div>
                );
            }
        },
        {
            dataField: "action",
            text: "Action",
            formatter: (cell, row) => {
                const isDisapproved = row?.status === 2 || row?.active === 2;
                const isApproved = row?.status === 1 || row?.active === 1;

                return (
                    <div className="editdropdown"
                        onClick={() => setActiveId(row.id)}
                        onMouseLeave={() => setActiveId(null)}
                        id={`moreOption`}>
                        <span className="editdropdown-button">
                            <FaEllipsisVertical />
                        </span>
                        <div className={`editdropdown-menu theme-bg-color ${activeId === row?.id ? "d-block" : "d-none"}  ${formData?.view_type}`}>
                            <button
                                type="button"
                                className="theme-text-color theme-bg-color btn w-100 text-start  border-0"
                                onClick={() => openModal("approve", [row.id])}
                                disabled={isApproved}
                                style={{
                                    opacity: isApproved ? 0.5 : 1,
                                    cursor: isApproved ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <MessageBox text="Approve" classname='ms-2 theme-text-color' />
                            </button>
                            <button
                                type="button"
                                className="theme-text-color theme-bg-color btn w-100 text-start border-0"
                                onClick={() => openModal("reject", [row.id])}
                                disabled={isDisapproved}
                                style={{
                                    opacity: isDisapproved ? 0.5 : 1,
                                    cursor: isDisapproved ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <MessageBox text="Disapproved" classname='ms-2 theme-text-color' />
                            </button>
                        </div>
                    </div >
                )
            }
        },
    ];

    const options = {
        pageStartIndex: 1,
        paginationSize: 3,
        sizePerPage: 10,
        sizePerPageList: [
            { text: '5', value: 5, id: "optionOne" },
            { text: '10', value: 10, id: "optionTwo" },
            { text: 'All', value: total?.totalItems, id: "optionThree" }
        ]
    };

    useEffect(() => { setLoading(false); }, []);

    // ===========================
    // JSX RETURN
    // ===========================
    return (
        <div className='mb-4'>
            {showOverlay && <Response_Processing />}

            <ConfirmationModal
                visible={modalVisible}
                action={modalAction}
                count={modalContentIds.length}
                onConfirm={confirmModalAction}
                onClose={closeModal}
            />

            <h3 className='theme-text-color mb-3'>Partner Content Approval </h3>
            <div className='theme-bg-color p-3 rounded-3 mb-5'>
                <div className='col-lg-12 row mb-3'>
                    <div className='col-lg-6 col-sm-6 col-md-6 col-6'>
                        <MessageLabel text="Choose the Partner" className="mandatorySimple  " />
                        <select
                            name="partner_list"
                            id="partner_list"
                            className="custom-input custom-input-border custom-placeholder w-100 bg-transparent theme-text-color"
                            value={selectedPartner}
                            onChange={(e) => setSelectedPartner(e.target.value)}
                        >
                            {datapartner?.map((partner) => (
                                <option key={partner.id} value={partner.id}>
                                    {partner.user_username || partner.user_name || partner.name || partner.username || `Partner #${partner.id}`}{partner.parent_id ? ` (Under ${partner.parent_partner_name})` : ""}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-lg-6 col-sm-6 col-md-6 col-6'>
                        <MessageLabel text="Choose the Source Type" className="mandatorySimple  " />
                        <select
                            name="content_source"
                            id="content_source"
                            className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color ms-3"
                            value={selectedSource}
                            onChange={(e) => setSelectedSource(e.target.value)}
                        >
                            <option value="1">Video</option>
                            <option value="3">Series</option>
                            <option value="4">Episode</option>
                            <option value="2">Live Stream</option>
                            <option value="5">Audio</option>
                        </select>
                    </div>
                </div>

                <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
                    <input
                        type='search'
                        placeholder='Search'
                        name="title"
                        className='rounded-3 col-3 theme-border-color border-solid-width border-solid table-search theme-bg-color-secondary'
                        onChange={handleInput}
                        id='searchInput'
                    />
                    <div className='d-flex align-items-center justify-content-end'>
                        <button
                            className={`bg-transparent custom-tool-tip-parent position-relative reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color`}
                            onClick={reloadAction}
                            id='reloadButton'
                        >
                            <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                            <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                        </button>

                        <div className="me-2">
                            <button
                                className="btn btn-success me-2"
                                disabled={itemToApproval.length === 0}
                                onClick={() => openModal("approve", itemToApproval)}
                            >
                                Approve ({itemToApproval.length})
                            </button>
                            <button
                                className="btn btn-danger"
                                disabled={itemToApproval.length === 0}
                                onClick={() => openModal("reject", itemToApproval)}
                            >
                                Disapproved ({itemToApproval.length})
                            </button>
                        </div>

                        <div className='position-relative custom-tool-tip-parent'>
                            {/* <AdminCustomSelect
                                name="view_type"
                                value={formData?.view_type}
                                onChange={handleInput}
                                options={formData?.view_type_option?.map((item) => ({ name: item?.name, value: item?.value }))}
                                defaultOptionName={""}
                                className="px-4 py-2 select-view-type"
                                noMargin
                                id="viewTypeSelectOption"
                            /> */}
                            <AdminTooltip text="View Type" top={"-41px"} className="d-none custom-tool-tip" />
                        </div>

                        <div className="dropdown d-block ms-2">
                            <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="fw-bolder text-white">Export</span>
                                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                            </button>
                            <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton">
                                <li className="dropdown-item theme-text-color" id='exportCSV' onClick={() => donwloadCSV(apiData, "LIBRARY-LIST")}>CSV</li>
                                <li className="dropdown-item theme-text-color" id='exportPDF' onClick={() => downloadPDF(apiData, "LIBRARY-LIST", ["INDEX", "ID", "TITLE", "DURATION", "SOURCE TYPE", "UPLOADED_BY"])}>PDF</li>
                                <li className="dropdown-item theme-text-color" id='exportXLSX' onClick={() => downloadXLSX(apiData, "LIBRARY-LIST", ["INDEX", "ID", "TITLE", "DURATION", "SOURCE TYPE", "UPLOADED_BY"])}>XLSX</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {noSelectionYet && apiData.length === 0 && (
                    <div className="p-5 text-center">
                        <h5>No data found — choose Partner and Content Source to load pending items.</h5>
                    </div>
                )}

                {!noSelectionYet && !loading && apiData.length === 0 && (
                    <div className="p-5 text-center">
                        <h5>No pending items found on this Partner.</h5>
                    </div>
                )}

                {(loading || apiData.length > 0) && (
                    <AdminTable
                        data={apiData}
                        loading={loading}
                        options={options}
                        handlePageChange={handlePageChange}
                        page={page}
                        pagination={total}
                        handleSizePerPageChange={handleSizePerPageChange}
                        columns={columns}
                        limit={limit}
                        selectRow={selectRow}
                        onRowSelect={handleRowSelect}
                        onSelectAll={handleSelectAll}
                        multiSelect
                        viewType={formData?.view_type}
                    />
                )}
            </div >
        </div >
    );
};

const mapStateToProps = (state) => ({
    permissionData: state.userPermission.permissionData,
});
export default connect(mapStateToProps)(AllPartnercontent);
